$(function() {
    $('.result--map', '.map-content__results').on('click', function(e) {
        e.preventDefault();
        openItinerary($(this).data('url'));
    });

    $('.result__close').on('click', function (e) {
        e.preventDefault();
        closeItinerary();
    });

    $('.map-content__button').on('click', function(e) {
        e.preventDefault();
        fullScreenMap();

        if ($(this).hasClass('map-content__button--hide')) {
            $('.map-content--hide').hide();
        }
    });

    var openItinerary = function (url) {
        closeItinerary();

        var mapData = [];

         // Access API to get itinerary data
        $.get(url, function(data) {
            var result = $('.map-content__results .result--map-listing');

            result.find('.result__title').html(data.api.data.itinerary.title);
            result.find('.result__image').html(data.api.data.itinerary.image);
            result.find('.result__intro').html(data.api.data.itinerary.intro);
            result.find('.result__duration').html(data.api.data.itinerary.duration);
            result.find('.result__price').html(data.api.data.itinerary.price);

            $('.result--map-listing').addClass('result--map-listing--open');
            result.attr('href', data.api.data.itinerary.url);

            $('.result--map').addClass('result--map--close');

            $('.map-content__map').hide();
            $('#itinerary-map').show();

            window.itinMap = new NewMap('#itinerary-map', {});

            // Default zoom to 13
            window.zoom = 13;

            // If one point then we get the zoom from the data
            if (data.api.data.itinerary.map.length > 1) {
                window.zoom = data.api.data.itinerary.map[0].zoom;
            }

            $.each(data.api.data.itinerary.map, function(key, value) {
                window.itinMap.addMarker({
                    lat: value.lat,
                    lng: value.lng,
                    interval: key
                });
            });
        })
            .fail(function(data) {
                console.log(data);
            });
    };

    var closeItinerary = function () {
        $('.result--map').removeClass('result--map--close');
        $('.result--map-listing').removeClass('result--map-listing--open');
        $('.map-content__map').show();
        $('#itinerary-map').html('');
        $('#itinerary-map').hide();
    }

    var fullScreenMap = function() {
        $('body').toggleClass('body--fullscreen');
        $('.fullscreen-map').toggleClass('fullscreen-map--fixed');
        $('.map-content__button svg').toggle();
        $('.map-content__button div').toggle();
        $('.map-content__button div svg').toggle();
        window.initMap();
        // this may or may not be crazy
        if (window.itinMap != undefined) {
            google.maps.event.trigger(window.itinMap.map, "resize");
        }
        $('.grid-action').toggle();
    };

    $('#map-small').on('click', function() {
        $('.map-content--hide').show();
        window.initMap();
        fullScreenMap();
    });
});
